import { environment } from './../../../../../environment/environment';
import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { CLogin } from './../../../../core/models/login';
import { AuthService } from './../../../../core/services/auth-service/auth.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  codeSended,
  invalidMailPassword,
  noAccountCandidateMail,
  noAccountMail,
  notVerifiedEmail,
  serverError,
  welcomeMessage,
} from './../../../../core/models/messages';
import {
  patternEmail,
  patternPassword,
} from './../../../../core/models/pattern';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-loginintervenant',
  templateUrl: './loginintervenant.component.html',
  styleUrls: ['./loginintervenant.component.css'],
})
export class LoginintervenantComponent implements OnInit {
  /* boolean */
  loadSpinner: boolean = false;
  showPassword: string = 'password';
  show_button_resend: boolean = false;
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  invalidCredentials: string = '';
  noUserAccount: string = '';
  validEmaill: string = '';
  company_id: any;

  generateLoginForm: FormGroup = this.loginForm(new CLogin());
  show_button_login: boolean = true;
  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private router: Router,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        console.log('routes', params.params['company_id']);
        this.company_id = params.params['company_id'];
      },
    });
  }

  /* create login form */
  loginForm(data: CLogin) {
    return this.formBuilder.group({
      username: [
        data.email,
        [
          Validators.required,
          Validators.email,
          Validators.pattern(patternEmail),
        ],
      ],
      password: [
        '',
        [Validators.required, Validators.pattern(patternPassword)],
      ],
    });
  }
  login() {
    this.invalidCredentials = '';
    this.noUserAccount = '';
    this.validEmaill = '';
    if (this.generateLoginForm.valid) {
      this.loadSpinner = true;

      const body = {
        ...this.generateLoginForm.value,
        company_id: this.localStorageService.getData('clientConnected'),
      };
      console.log(body);
      this.authService
        .login(body)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res: any) => {
            this.loadSpinner = false;

            if (
              res.status === 200 &&
              (res.data.role_user_id == 9 ||
                res.data.role_user_id == 8 ||
                res.data.role_user_id == 7)
            ) {
              this.toastrService.success(welcomeMessage);
              this.authService.setCookies('token', res.token['access_token']);
              this.authService.setCookies(
                'refresh_token',
                res.token['refresh_token']
              );
              this.localStorageService.saveData('id', res.data.id);

              this.localStorageService.saveData(
                'clientConnected',
                this.company_id
              );

              this.localStorageService.saveData(
                'clientConnectedName',
                res.data.company.name
              );

              this.localStorageService.saveData(
                'UserInfo',
                JSON.stringify(res.data)
              );

              //   const url = '/accueil';
              //  window.location.href = url
            } else {
              this.toastrService.error(noAccountCandidateMail);
            }
          },
          error: (err: any) => {
            this.loadSpinner = false;
            if (err?.error) {
              switch (err?.error.status) {
                case 406:
                  this.toastrService.error(notVerifiedEmail);
                  this.show_button_login = false;
                  this.show_button_resend = true;

                  break;
                case 404:
                  this.noUserAccount = noAccountMail;

                  break;
                case 401:
                  this.invalidCredentials = invalidMailPassword;
                  break;
                default:
                  this.toastrService.error(serverError);
                  break;
              }
            }
          },
        });
    }
  }
  /* sending mail to verif code */

  resendCodeVerification() {
    const data = { email: this.generateLoginForm.value.username };
    this.authService
      .resendCodeVerification(data)
      .pipe()
      .subscribe({
        next: (data) => {
          console.log('data', data);
          this.toastrService.success(codeSended);
          this.router.navigate([
            '/auth/code-verification',
            { email: this.generateLoginForm.value.username },
          ]);
        },
        error: (err) => {
          console.log('error', err);
          if (err?.error) {
            this.toastrService.error(err);
          }
        },
      });
  }

  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
